import { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import { AdminTemplate } from '../../components';
import { ResponseCodeTable } from '../../components/organisms/response-code/ResponseCodeTable';
import { NewResponseCodeTable } from '../../components/organisms/response-code/NewResponseCodeTable';
import { ExcelUpload } from '../../components/molecules/ExcelUpload';
import { useAddResponseCodeWithExcelMutation } from '../../hooks/response-code/useAddResponseCodeWithExcelMutation';
import { useSetSnackBar } from "../../store/Snackbar.state";
import { UploadResult } from '../../components/molecules/UploadResult';

interface UploadResultData {
  totalRecord: number;
  successRecord: number;
  failRecord: number;
  errorMessages: string[];
}

export const ResourceManagement = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [uploadResult, setUploadResult] = useState<UploadResultData | null>(null);
  const setSnackbar = useSetSnackBar();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  const addResponseCodeWithExcelMutation = useAddResponseCodeWithExcelMutation();

  const handleExcelUpload = (file: File) => {
    setUploadResult(null);
    addResponseCodeWithExcelMutation.mutate(file, {
      onSuccess: (response) => {
        if (response.data.isSuccess) {
          setUploadResult(response.data.data);
          setSnackbar({
            severity: "success",
            isOpen: true,
            description: response.data.message || 'İşlem tamamlandı.',
          });
        } else {
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: response.data.message || 'Bir hata oluştu.',
          });
        }
      },
      onError: () => {
        setUploadResult(null);
        setSnackbar({
          severity: "error",
          isOpen: true,
          description: 'Excel dosyası yüklenirken bir hata oluştu.',
        });
      },
    });
  };

  return (
    <AdminTemplate headerProps={{ headerTitle: 'Hata Kodu Yönetimi', hideAddButton: true }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={selectedTab} onChange={handleChange} aria-label="resource management tabs">
          <Tab label="Banka Hata Kodları" />
          <Tab label="Yeni Hata Kodları" />
          <Tab label="Excel ile Yükle" />
        </Tabs>
      </Box>
      <TabPanel value={selectedTab} index={0}>
        <ResponseCodeTable />
      </TabPanel>
      <TabPanel value={selectedTab} index={1}>
        <NewResponseCodeTable />
      </TabPanel>
      <TabPanel value={selectedTab} index={2}>
        <ExcelUpload
          onUpload={handleExcelUpload}
          sampleFileUrl="/files/toplu-banka-hata-kodu-yonlendirme-ornek.xlsx"
          isLoading={addResponseCodeWithExcelMutation.isLoading}
        />
        {uploadResult && <UploadResult data={uploadResult} />}
      </TabPanel>
    </AdminTemplate>
  );
};

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
